import React from "react";
import { useSelector } from "react-redux";
import { Calendar1Icon } from "lucide-react";
import {
  formatGoogleDateTime,
  generateICSFile,
} from "../../utils/iosAddToCalendar";

const AddToCalendarButton = ({
  title,
  description,
  callLink,
  recurrenceType,
  start,
  end,
  date,
  className = "py-2 px-4 flex gap-2 items-center bg-[#000000] text-white rounded-[8px] text-[14px] leading-[24px] w-full justify-center",
}) => {
  const user = useSelector((state) => state.user);
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Compute calStart and calEnd
  let startDateStr = "";
  let startTimeStr = "";
  let endDateStr = "";
  let endTimeStr = "";

  if (start && String(start).includes("T")) {
    const [d, t] = String(start).split("T");
    startDateStr = d;
    startTimeStr = t.split(".")[0];
  } else {
    startDateStr = date || new Date().toISOString().split("T")[0];
    startTimeStr = start || "00:00:00";
  }

  if (end && String(end).includes("T")) {
    const [d, t] = String(end).split("T");
    endDateStr = d;
    endTimeStr = t.split(".")[0];
  } else {
    endDateStr = startDateStr;
    if (end) {
      endTimeStr = end;
    } else {
      // Fallback: add 1 hour
      const parts = startTimeStr.split(":");
      const h = parts[0] ? parseInt(parts[0], 10) : 0;
      const m = parts[1] ? parseInt(parts[1], 10) : 0;
      const s = parts[2] ? parseInt(parts[2], 10) : 0;
      const nextHour = (h + 1) % 24;
      endTimeStr = `${String(nextHour).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    }
  }

  const calStart = formatGoogleDateTime(startDateStr, startTimeStr);
  const calEnd = formatGoogleDateTime(endDateStr, endTimeStr);

  const isAppleDevice = () => {
    return (
      /iPad|iPhone|iPod|Macintosh/i.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    );
  };

  const addToGoogleCalendar = () => {
    try {
      const desc = description || title || "";
      const recurrence =
        recurrenceType === "daily"
          ? "RRULE:FREQ=DAILY"
          : recurrenceType === "weekly"
            ? "RRULE:FREQ=WEEKLY"
            : "";

      const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
        title || "",
      )}&dates=${encodeURIComponent(
        `${calStart}/${calEnd}`,
      )}&ctz=${encodeURIComponent(
        userTimezone,
      )}&recur=${encodeURIComponent(recurrence)}&add=${encodeURIComponent(
        user?.email || "",
      )}&details=${encodeURIComponent(
        `${desc}\nMeeting link: ${callLink || ""}`,
      )}&location=${encodeURIComponent(callLink || "")}`;

      window.open(googleCalendarUrl, "_blank");
    } catch (error) {
      console.error("Failed to open Google Calendar:", error);
    }
  };

  const handleAddToCalendar = () => {
    if (isAppleDevice()) {
      generateICSFile({
        title,
        description,
        start: calStart,
        end: calEnd,
        location: callLink,
        recurrence: recurrenceType,
      });
    } else {
      addToGoogleCalendar();
    }
  };

  return (
    <button className={className} onClick={handleAddToCalendar}>
      <Calendar1Icon />
      Add to calendar
    </button>
  );
};

export default AddToCalendarButton;
